/** Items per page options for list/card views across Karuna admin & school portals */
export const KARUNA_PAGE_SIZE_OPTIONS = [100, 500, 1000] as const;

export type KarunaPageSize = (typeof KARUNA_PAGE_SIZE_OPTIONS)[number];

export const KARUNA_DEFAULT_PAGE_SIZE: KarunaPageSize = 100;

export const KARUNA_PAGE_SIZE_STORAGE_KEY = "karuna_list_page_size";

export const KARUNA_PAGE_SIZE_CHANGE_EVENT = "karuna-page-size-change";

export function isKarunaPageSize(value: number): value is KarunaPageSize {
  return (KARUNA_PAGE_SIZE_OPTIONS as readonly number[]).includes(value);
}

export function readKarunaPageSize(): KarunaPageSize {
  try {
    const raw = localStorage.getItem(KARUNA_PAGE_SIZE_STORAGE_KEY);
    const parsed = Number(raw);
    if (isKarunaPageSize(parsed)) {
      return parsed;
    }
  } catch {
    // ignore private mode / unavailable storage
  }
  return KARUNA_DEFAULT_PAGE_SIZE;
}

export function writeKarunaPageSize(size: KarunaPageSize): void {
  try {
    localStorage.setItem(KARUNA_PAGE_SIZE_STORAGE_KEY, String(size));
    window.dispatchEvent(
      new CustomEvent<KarunaPageSize>(KARUNA_PAGE_SIZE_CHANGE_EVENT, {
        detail: size,
      })
    );
  } catch {
    // ignore
  }
}

/** @deprecated Use readKarunaPageSize() — kept for any stale imports */
export const KARUNA_PAGE_SIZE = KARUNA_DEFAULT_PAGE_SIZE;
